import { render, staticRenderFns } from "./NewItemLoginPage.vue?vue&type=template&id=ef35ef08&"
import script from "./NewItemLoginPage.vue?vue&type=script&lang=js&"
export * from "./NewItemLoginPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports